/* eslint-disable @typescript-eslint/ban-ts-comment */
import PropTypes from 'prop-types';
import { useCallback, useEffect, useState } from 'react';
// eslint-disable-next-line import/no-extraneous-dependencies
import PubSub from 'pubsub-js';
import { useSearchParams } from 'react-router-dom';

import { ListPaginated } from '@febos-io/design';
import { hooks as commonHooks, ListFilter } from '@febos-io/common';

import { useTranslation } from '../hooks';
import { themesType } from '../config';
import useDocumentExamListCallback from '../hooks/useDocumentExamListCallback';

const LIMIT = 10;

export function DocumenExamtList({
  type,
  HeaderComponent,
  RowComponent,
  configEnabledFilters,
  configFixedFilters,
  AddNewButton,
  GetReportButton,
  formatReport,
  toAddNewButton,
  rolesAddNewButton,
  titleAddNewButton,
  sort
}) {
  const { t } = useTranslation();
  const [isInit, setIsInit] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();
  const [page, setPage] = useState(+(searchParams.get('page') || 1));
  const [actualFilters, setActualFilters] = useState('');
  const {
    loading,
    elements,
    meta: { pages },
    callback
  } = useDocumentExamListCallback(LIMIT, sort);

  const handlerFilter = useCallback(
    (filter) => {
      if (isInit) {
        setPage(1);
      } else {
        setIsInit(true);
      }
      setActualFilters(filter);
    },
    [isInit]
  );

  const callList = commonHooks.useDebounceCallback(callback, [callback]);

  const handlerListCall = useCallback(() => {
    callList(actualFilters, page);
  }, [actualFilters, callList, page]);

  useEffect(() => {
    if (isInit) {
      // @ts-ignore
      const params = new URLSearchParams({
        page,
        filter: actualFilters
      });
      setSearchParams(params);
      handlerListCall();
    }
  }, [page, actualFilters, isInit, setSearchParams, handlerListCall]);
  useEffect(() => {
    const subscription = PubSub.subscribe(themesType.RELOAD_LIST, () => handlerListCall());
    return () => {
      PubSub.unsubscribe(subscription);
    };
  }, [handlerListCall]);
  return (
    <>
      <div className="row justify-content-between">
        <div className="col">
          <span>
            <ListFilter
              initialFilter={searchParams.get('filter') || ''}
              configEnabledFilters={configEnabledFilters}
              configFixedFilters={configFixedFilters}
              // @ts-ignore
              onFilter={handlerFilter}
              // @ts-ignore
              onReload={handlerListCall}
              // @ts-ignore
              contentFilter="content"
              searchTitle={t('Search')}
            />
          </span>
        </div>
        {AddNewButton && (
          <AddNewButton
            roles={rolesAddNewButton || ['superadmin', 'support', 'radiologytechnician']}
            to={toAddNewButton || '/dental/orders/new'}
            title={titleAddNewButton || 'New Order'}
          />
        )}
        {GetReportButton && (
          <div className="col-2 text-end">
            <GetReportButton
              roles={['superadmin', 'support', 'radiologytechnician', 'radiologist']}
              title="Download"
              filters={actualFilters}
              format={formatReport}
              type={type}
              currentPage={page}
              limit={LIMIT}
            />
          </div>
        )}
      </div>
      <ListPaginated
        HeaderComponent={HeaderComponent}
        RowComponent={RowComponent}
        currentPage={page}
        // @ts-ignore
        onPageChange={setPage}
        pages={pages}
        loading={loading}
        elements={elements}
        // @ts-ignore
        onReload={handlerListCall}
      />
    </>
  );
}

DocumenExamtList.propTypes = {
  type: PropTypes.string.isRequired,
  HeaderComponent: PropTypes.elementType,
  RowComponent: PropTypes.elementType.isRequired,
  configEnabledFilters: PropTypes.object,
  configFixedFilters: PropTypes.object,
  AddNewButton: PropTypes.elementType,
  GetReportButton: PropTypes.elementType,
  formatReport: PropTypes.string,
  toAddNewButton: PropTypes.string,
  rolesAddNewButton: PropTypes.array,
  titleAddNewButton: PropTypes.string,
  sort: PropTypes.string
};

export default DocumenExamtList;
